import React, { useEffect } from "react";
import useStyles from "./styles";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import CeroInput from "../../../../components/CeroInput";
import AssetValueTable from "../RiskTable/AssetValue";
import MarketServedTable from "../RiskTable/marketServed";
import SupplyChainTable from "../RiskTable/SupplyChain";
import DownstreamTable from "../RiskTable/Downstream";
import LawRegulationTable from "../RiskTable/LawRegulations";
import CeroPhoneInput from "../../../../components/CeroPhoneInput";
import CeroDate from "../../../../components/CeroDate";
import MaterialTopics from "../RiskTable/MaterialTopics";

function GriQuestionnaire({
  handleCheckboxChange,
  handleSingleSelect,
  handleTextInputChange,
  textAnswers,
  selectedValues,
  assetValueTable,
  setAssetValueTable,
  marketReservedTable,
  setmarketReservedTable,
  supplyChainTable,
  setSupplyChainTable,
  downstreamTable,
  setDownstreamTable,
  lawRegulationTable,
  setLawRegulationTable,
  materialTopicsTable,
  setMaterialTopicsTable,
  handleDateInputChange,
  dateAnswers,
}) {
  const classes = useStyles();
  const materialityQuestions = useSelector((state) => {
    const data = state.emission.getStandardsQuestionnaire.data.questions_list;
    return Array.isArray(data) ? data : [];
  });

  const specificQuestionId = "Date of publication";
  useEffect(() => {
    const existingAnswer = textAnswers[specificQuestionId];
    if (!existingAnswer || existingAnswer === "") {
      const today = new Date().toLocaleDateString("en-GB");
      handleTextInputChange(specificQuestionId, today);
    }
  }, [specificQuestionId]);

  const questionDict = {};
  const subQuestionDict = {};
  function toRoman(num) {
    const romanMap = {
      1: "I",
      2: "II",
      3: "III",
      4: "IV",
      5: "V",
      6: "VI",
      7: "VII",
      8: "VIII",
      9: "IX",
      10: "X",
      11: "XI",
      12: "XII",
      13: "XIII",
      14: "XIV",
      15: "XV",
    };

    return romanMap[num] || "Invalid number";
  }
  materialityQuestions.forEach(
    ({
      main_section,
      section,
      question,
      category,
      question_type,
      options,
      id,
      condition,
      question_id,
    }) => {
      // Ensure the section exists
      if (!questionDict[main_section]) {
        questionDict[main_section] = {};
      }

      // Ensure the sub_section exists
      if (!questionDict[main_section][section]) {
        questionDict[main_section][section] = [];
      }
      if (question_id !== "None") {
        if (!subQuestionDict[question_id]) {
          subQuestionDict[question_id] = [];
        }
        subQuestionDict[question_id].push({
          question,
          category,
          question_type,
          options,
          id,
          condition,
          question_id,
        });
      }
      // Add the question to the appropriate section
      questionDict[main_section][section].push({
        question,
        category,
        question_type,
        options,
        id,
        condition,
        question_id,
      });
    }
  );

  return (
    <div>
      {materialityQuestions.length > 0 && (
        <Grid mb={20}>
          <div className={classes.questionList}>
            {Object.keys(questionDict).map((section, sectionIndex) => (
              <React.Fragment key={sectionIndex}>
                <div className={classes.scoreDiv}>
                  <Typography
                    fontSize={20}
                    fontWeight={550}
                    variant="h3"
                    paddingTop="10px"
                  >
                    {`${section}`.toLocaleUpperCase()}
                  </Typography>
                </div>
                {Object.keys(questionDict[section]).map(
                  (subSection, subIndex) => {
                    let displayCounter = 1;

                    return (
                      <div>
                        <Typography
                          fontSize={19}
                          fontWeight={450}
                          variant="h4"
                          paddingTop="10px"
                        >
                          {`${toRoman(subIndex + 1)}. ${subSection}`}
                        </Typography>

                        {questionDict[section][subSection].map(
                          (question, qtnIdx) => {
                            let displayIndex = null;

                            const isHeadingOnly =
                              !question.question_type &&
                              !question.options?.length;

                            const isIfYesByText = question?.question
                              ?.toLowerCase()
                              ?.startsWith("if yes");
                            const isLinkedSubQuestion =
                              question.question_id &&
                              question.question_id !== "None";
                            const isSubQuestion =
                              isIfYesByText || isLinkedSubQuestion;

                            const parentQuestionId = isLinkedSubQuestion
                              ? question.question_id
                              : questionDict[section][subSection][qtnIdx - 1]
                                  ?.id;

                            const parentQuestion = questionDict[section][
                              subSection
                            ]?.find((q) => q.id === parentQuestionId);
                            let isYesSelected = false;

                            if (
                              parentQuestion?.question_type ===
                              "multiselect_check_box"
                            ) {
                              const selected =
                                selectedValues?.[parentQuestionId];
                              isYesSelected =
                                Array.isArray(selected) && selected.length > 0;
                            } else {
                              isYesSelected =
                                selectedValues?.[parentQuestionId] === "Yes";
                            }

                            const isParentHeadingOnly =
                              parentQuestion?.question_type === "";

                            const isMaterialTopicsGroup =
                              question.question_type ===
                                "multiselect_check_box" &&
                              [
                                "Social:",
                                "Environmental:",
                                "Economic:",
                              ].includes(question.question);

                            if (
                              isSubQuestion &&
                              !isYesSelected &&
                              !isParentHeadingOnly &&
                              !isMaterialTopicsGroup
                            ) {
                              return null;
                            }

                            if (!isSubQuestion) displayIndex = displayCounter++;

                            return (
                              <Grid
                                key={question?.id}
                                className={
                                  question.question_type === "text" ||
                                  question.question_type === "Text Field"
                                    ? classes.inputGrid
                                    : classes.gridItem
                                }
                              >
                                {question?.question !== "" && (
                                  <>
                                    {question.question.includes(
                                      "Provide examples of how stakeholder engagement has directly influenced"
                                    ) ? (
                                      <>
                                        <Typography
                                          fontSize={18}
                                          fontWeight={500}
                                          variant="h3"
                                          paddingLeft={4}
                                          paddingBottom={2}
                                        >
                                          {displayIndex}.{" "}
                                          {question?.question
                                            .split("(")
                                            .map((part, index) =>
                                              index === 0
                                                ? part.trim()
                                                : `(${part}`
                                            )
                                            .join(" ")}{" "}
                                        </Typography>
                                        <Typography
                                          fontSize={16}
                                          fontWeight={400}
                                          paddingLeft={6}
                                          paddingBottom={2}
                                          sx={{ whiteSpace: "pre-line" }}
                                        >
                                          i. The design or implementation of
                                          actions to address impacts.{"\n"}
                                          ii. The evaluation of the
                                          effectiveness of these actions. (E.g.,
                                          stakeholders recommending alternative
                                          solutions, highlighting additional
                                          areas of concern)
                                        </Typography>
                                      </>
                                    ) : (
                                      <Typography
                                        fontSize={18}
                                        fontWeight={500}
                                        variant="h3"
                                        paddingLeft={4}
                                        paddingBottom={2}
                                      >
                                        {displayIndex !== null &&
                                          `${displayIndex}. `}
                                        {question?.question
                                          .split("(")
                                          .map((part, index) =>
                                            index === 0
                                              ? part.trim()
                                              : `(${part}`
                                          )
                                          .join(" ")}{" "}
                                      </Typography>
                                    )}
                                  </>
                                )}
                                <Box
                                  display="flex"
                                  paddingLeft={6}
                                  flexWrap="wrap"
                                >
                                  {(question?.question_type ===
                                    "choose_from_option" ||
                                    question?.question_type ===
                                      "Choose from Options") && (
                                    <div
                                      style={{
                                        display: "grid",
                                        // gridTemplateColumns: "repeat(4, 1fr)",
                                        gridTemplateColumns: `repeat(${
                                          question.options.some(
                                            (option) =>
                                              option.split(" ").length > 5
                                          )
                                            ? 2
                                            : 4
                                        }, 1fr)`,
                                        gap: "16px",
                                        alignItems: "left",
                                        position: "relative",
                                        textAlign: "left",
                                      }}
                                    >
                                      {question?.options?.map((option, idx) => (
                                        <React.Fragment key={idx}>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                className={
                                                  classes.selectCheckbox
                                                }
                                                checked={
                                                  selectedValues &&
                                                  selectedValues[
                                                    question?.id
                                                  ] === option
                                                }
                                                onChange={() =>
                                                  handleSingleSelect(
                                                    question.id,
                                                    option
                                                  )
                                                }
                                                value={option}
                                                sx={{
                                                  color: "#5A404E !important",
                                                  borderWidth: "none",
                                                  "&.Mui-checked": {
                                                    color: "#8C2148 !important",
                                                  },
                                                }}
                                              />
                                            }
                                            label={option}
                                          />
                                          {selectedValues[question.id] ===
                                            "Other (Please specify):" &&
                                            option ===
                                              "Other (Please specify):" && (
                                              <TextField
                                                variant="outlined"
                                                placeholder="Please type your Answer"
                                                multiline
                                                rows={3}
                                                value={
                                                  textAnswers[
                                                    `other-${question.id}`
                                                  ] || ""
                                                }
                                                onChange={(e) =>
                                                  handleTextInputChange(
                                                    `other-${question.id}`,
                                                    e.target.value
                                                  )
                                                }
                                                className={classes.input}
                                              />
                                            )}
                                        </React.Fragment>
                                      ))}
                                    </div>
                                  )}
                                  {question.question?.startsWith(
                                    "If the information about Governance structure and composition of the organization is publicly available (web pages or annual reports), then provide the link in the GRI content index instead of repeating it."
                                  ) && (
                                    <Box
                                      width="100%"
                                      display="flex"
                                      justifyContent="center"
                                    >
                                      <Typography
                                        fontSize={16}
                                        fontWeight={600}
                                        sx={{
                                          paddingTop: 15,
                                          paddingBottom: -6,
                                          color: "#000",
                                          lineHeight: 1,
                                        }}
                                      >
                                        OR
                                      </Typography>
                                    </Box>
                                  )}

                                  {question.condition === "question_split" &&
                                    question.options?.length > 0 && (
                                      <ul
                                        style={{
                                          marginTop: "8px",
                                          paddingLeft: "24px",
                                          color: "#555",
                                        }}
                                      >
                                        {question.options.map((opt, idx) => (
                                          <li
                                            key={idx}
                                            style={{
                                              fontSize: "16px",
                                              marginBottom: "4px",
                                              lineHeight: "1.5",
                                              color: "#000",
                                            }}
                                          >
                                            {opt}
                                          </li>
                                        ))}
                                      </ul>
                                    )}

                                  {question.question_type ===
                                    "multiselect_check_box" && (
                                    <div
                                      style={{
                                        display: "grid",
                                        // gridTemplateColumns: "repeat(4, 1fr)",
                                        gridTemplateColumns: `repeat(${
                                          question.options.some(
                                            (option) =>
                                              option.split(" ").length > 6
                                          )
                                            ? 2
                                            : 4
                                        }, 1fr)`,
                                        gap: "16px",
                                        alignItems: "left",
                                        position: "relative",
                                        textAlign: "left",
                                      }}
                                    >
                                      {question.options.map((option, idx) => (
                                        <React.Fragment key={idx}>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                className={
                                                  classes.selectCheckbox
                                                }
                                                checked={
                                                  selectedValues[
                                                    question.id
                                                  ]?.includes(option) || false
                                                }
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    e,
                                                    question.id
                                                  )
                                                }
                                                value={option}
                                                sx={{
                                                  color: "#5A404E !important",
                                                  "&.Mui-checked": {
                                                    color: "#8C2148 !important",
                                                  },
                                                  marginRight: "8px",
                                                }}
                                              />
                                            }
                                            label={option}
                                            sx={{
                                              margin: "0 !important",
                                              width: "fit-content",
                                            }}
                                          />

                                          {selectedValues[
                                            question.id
                                          ]?.includes(
                                            "Other (Please specify):"
                                          ) &&
                                            option ===
                                              "Other (Please specify):" && (
                                              <div
                                                style={{
                                                  gridColumn: "1 / -1", // Span all columns
                                                  width: "100%",
                                                  marginTop: "16px",
                                                }}
                                              >
                                                <TextField
                                                  variant="outlined"
                                                  placeholder="Please type your Answer"
                                                  multiline
                                                  rows={3}
                                                  value={
                                                    textAnswers[
                                                      `other-${question.id}`
                                                    ] || ""
                                                  }
                                                  onChange={(e) =>
                                                    handleTextInputChange(
                                                      `other-${question.id}`,
                                                      e.target.value
                                                    )
                                                  }
                                                  sx={{
                                                    width: "100%",
                                                    "& .MuiOutlinedInput-root":
                                                      {
                                                        borderRadius: "8px",
                                                        borderColor: "#5A404E",
                                                      },
                                                  }}
                                                />
                                              </div>
                                            )}
                                        </React.Fragment>
                                      ))}
                                    </div>
                                  )}
                                  {(question.question_type === "text" ||
                                    question.question_type ===
                                      "Text Field") && (
                                    <>
                                      <Box minHeight={80} width={"100%"}>
                                        <CeroInput
                                          className={classes.textAreaContainer}
                                          rows={3}
                                          placeholder={
                                            "Please type your Answer"
                                          }
                                          id={`answer-${question.id}`}
                                          name={`answer-${question.id}`}
                                          label="Please type your Answer"
                                          multiline
                                          value={textAnswers[question.id] || ""}
                                          onChange={(e) =>
                                            handleTextInputChange(
                                              question.id,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </Box>

                                      {/* Show OR below input only for specific question */}
                                      {question.question?.startsWith(
                                        "If the information about Governance structure and composition of the organization is publicly available (web pages or annual reports), then provide the link in the GRI content index instead of repeating it."
                                      ) && (
                                        <Box
                                          width="100%"
                                          display="flex"
                                          justifyContent="center"
                                        >
                                          <Typography
                                            fontSize={16}
                                            fontWeight={600}
                                            sx={{
                                              paddingTop: 15,
                                              paddingBottom: -6, // ✅ Add this for subtle spacing
                                              color: "#000",
                                              lineHeight: 1,
                                            }}
                                          >
                                            OR
                                          </Typography>
                                        </Box>
                                      )}
                                    </>
                                  )}

                                  {question.question_type === "short_text" &&
                                    (question.question ===
                                    "Contact details of person for questions about the report." ? (
                                      <CeroPhoneInput
                                        required
                                        fullWidth
                                        label="Contact Number"
                                        name="contact number"
                                        value={textAnswers[question.id] || ""}
                                        onChange={(value, country) =>
                                          handleTextInputChange(
                                            question.id,
                                            value
                                          )
                                        }
                                        classes={{
                                          container: classes.phoneInput,
                                        }}
                                      />
                                    ) : (
                                      <Box width={"50%"}>
                                        <CeroInput
                                          classes={{
                                            container:
                                              classes.textAreaContainerShort,
                                            input:
                                              classes.textAreaContainerInput,
                                          }}
                                          rows={3}
                                          placeholder={
                                            "Please type your Answer"
                                          }
                                          id={`answer-${question.id}`}
                                          name={`answer-${question.id}`}
                                          label="Please type your Answer"
                                          multiline
                                          value={textAnswers[question.id] || ""}
                                          onChange={(e) =>
                                            handleTextInputChange(
                                              question.id,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </Box>
                                    ))}

                                  {question.question_type === "table" && (
                                    <Grid width={"100%"}>
                                      {question.instructions?.map((inst, i) => (
                                        <Typography
                                          paddingLeft={6}
                                          paddingY={1}
                                          key={i}
                                        >
                                          {i + 1}. {inst}
                                        </Typography>
                                      ))}
                                      {question.condition === "table_gri_1" ? (
                                        <AssetValueTable
                                          assetValueTable={assetValueTable}
                                          setAssetValueTable={
                                            setAssetValueTable
                                          }
                                        />
                                      ) : question.condition ===
                                        "table_gri_2" ? (
                                        <MarketServedTable
                                          marketReservedTable={
                                            marketReservedTable
                                          }
                                          setmarketReservedTable={
                                            setmarketReservedTable
                                          }
                                        />
                                      ) : question.condition ===
                                        "table_gri_3" ? (
                                        <SupplyChainTable
                                          supplyChainTable={supplyChainTable}
                                          setSupplyChainTable={
                                            setSupplyChainTable
                                          }
                                        />
                                      ) : question.condition ===
                                        "table_gri_4" ? (
                                        <DownstreamTable
                                          downstreamTable={downstreamTable}
                                          setDownstreamTable={
                                            setDownstreamTable
                                          }
                                        />
                                      ) : question.condition ===
                                        "table_gri_5" ? (
                                        <LawRegulationTable
                                          lawRegulationTable={
                                            lawRegulationTable
                                          }
                                          setLawRegulationTable={
                                            setLawRegulationTable
                                          }
                                        />
                                      ) : question.condition ===
                                        "table_gri_6" ? (
                                        <MaterialTopics
                                          materialTopicsTable={
                                            materialTopicsTable
                                          }
                                          setMaterialTopicsTable={
                                            setMaterialTopicsTable
                                          }
                                        />
                                      ) : (
                                        <></>
                                      )}
                                    </Grid>
                                  )}
                                  {question.question_type === "date" && (
                                    <CeroDate
                                      label="Date"
                                      value={dateAnswers[question.id] || ""}
                                      onChange={(date) =>
                                        handleDateInputChange(question.id, date)
                                      }
                                      year={2025}
                                    />
                                  )}
                                </Box>
                              </Grid>
                            );
                          }
                        )}
                      </div>
                    );
                  }
                )}
              </React.Fragment>
            ))}
          </div>
        </Grid>
      )}
    </div>
  );
}

export default GriQuestionnaire;
